import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { ColorIcon, colors, customEvent, NextLink } from "goi_common";

interface Props {
  sidoName: string | null;
  companyname: string;
}
function SeaBurialBreadcrumb({ sidoName, companyname }: Props) {
  return (
    <Breadcrumb
      itemScope
      itemType="https://schema.org/BreadcrumbList"
      textColor={colors.gray400}
      marginBottom="6px"
      spacing="4px"
      separator={<ColorIcon name="arrow" color={colors.gray400} size="8px" />}
    >
      <BreadcrumbItem itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
        <BreadcrumbLink
          as={NextLink}
          className="caption_12_m"
          href={`/match/recommendations/`}
          itemProp="item"
          onClick={() => {
            customEvent({
              newGtm: {
                path: "sea_burial_detail",
                trigger_and_target: "brdcrmb-uv_mtch_recomms",
              },
            });
          }}
        >
          <span itemProp="name">고이의 추천</span>
          <meta itemProp="position" content="1" />
        </BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbItem>
        <BreadcrumbLink className="caption_12_m">
          <span>{sidoName}지역 바다장</span>
        </BreadcrumbLink>
      </BreadcrumbItem>

      <BreadcrumbItem>
        <BreadcrumbLink className="caption_12_m">
          <span>{companyname}</span>
        </BreadcrumbLink>
      </BreadcrumbItem>
    </Breadcrumb>
  );
}

export default SeaBurialBreadcrumb;
